import mixinActions from '../core/actions';
import mixinMutations from '../core/mutations';
import mixinGetters from '../core/getters';

export default {
    namespaced: true,
    state: {
        bets: [],
        repositoryName: 'bets',
        filters: {
            date: [new Date().toISOString().slice(0, 10), new Date().toISOString().slice(0, 10)],
            bookmakerId: [],
            botId: [],
            tradingTypeId: null,
            orderId: null,
        },
        isShowExtraFilters: false,
    },
    mutations: {
        ...mixinMutations(),
    },
    getters: {
        ...mixinGetters(),
    },
    actions: {
        ...mixinActions('betFail'),
    },
};
